export class NotesParameterRanges {
  static readonly EXPERIMENT_NOTES = {
    minNoteLength: 1,
    maxNoteLength: 500,
  };

  static readonly CALIBRATION_NOTES = {
    minNoteLength: 1,
    maxNoteLength: 500,
  };

  static readonly ERROR_LOG_NOTES = {
    minNoteLength: 1,
    maxNoteLength: 250,
  };

  static readonly APPROVAL_INFO = {
    minNoteLength: 1,
    maxNoteLength: 100,
  };
}
